module.exports = __webpack_public_path__ + "static/film-87c978526b260cf929edb6ddbe30c3a1.jpg";